"use client";

import { useEffect } from "react";

/**
 * Some browser wallet extensions (multi-wallet "select which wallet" aggregators) throw an
 * unhandled EIP-1193 code-4001 "User rejected the request" from their OWN internal code when a
 * connect prompt is dismissed — with a stack entirely inside the extension, never our app. It is
 * benign (a declined wallet prompt) and our pay flow already handles real rejections. This
 * suppresses ONLY that specific noise so it doesn't surface as an uncaught console error; every
 * other rejection is left untouched.
 */
export function WalletNoise() {
  useEffect(() => {
    const isWalletReject = (reason: unknown): boolean => {
      const r = reason as { code?: number; message?: string } | undefined;
      const msg = r?.message ?? String(reason ?? "");
      return r?.code === 4001 || /user rejected|user denied/i.test(msg);
    };
    const onRejection = (e: PromiseRejectionEvent) => {
      if (isWalletReject(e.reason)) e.preventDefault(); // swallow benign wallet decline only
    };
    window.addEventListener("unhandledrejection", onRejection);
    return () => window.removeEventListener("unhandledrejection", onRejection);
  }, []);
  return null;
}
